import { jsx } from "react/jsx-runtime";
import { useState, useMemo, useCallback } from "react";
import { Checkbox } from "@perxis-auto/ui-kit/lib/components/Checkbox";
import { Collapse } from "@perxis-auto/ui-kit/lib/components/Collapse";
import { Icon } from "@perxis-auto/ui-kit/lib/components/Icon";
import { Typography } from "@perxis-auto/ui-kit/lib/components/Typography";
import clsx from "clsx";
import { sortCollectionItems } from "../../../../shared/lib/sort/sortCollectionItems.js";
import styles from "./FilterOptions.module.scss.js";
function FilterOptions({ value = [], options = [], className, onChange, ...props }) {
  const [activeKey, setActiveKey] = useState([]);
  const groupedOptions = useMemo(() => {
    return Object.values(
      options.reduce(
        (acc, option) => {
          if (!acc[option.group.id]) {
            acc[option.group.id] = [];
          }
          acc[option.group.id].push(option);
          return acc;
        },
        {}
      )
    ).sort((a, b) => sortCollectionItems(a[0].group, b[0].group));
  }, [options]);
  const handleChange = useCallback(
    (otherOptions) => (newValues) => {
      const otherOptionValues = otherOptions.filter((o) => value.includes(o.value)).map((o) => o.value);
      return onChange == null ? void 0 : onChange([...newValues, ...otherOptionValues]);
    },
    [onChange, value]
  );
  return /* @__PURE__ */ jsx(
    Collapse,
    {
      activeKey,
      onChange: (key) => setActiveKey(Array.isArray(key) ? key : [key]),
      items: groupedOptions.map((options2, index, self) => {
        const otherGroupedOptions = [...self];
        otherGroupedOptions.splice(index, 1);
        const otherOptions = otherGroupedOptions.flat();
        const { group } = options2[0];
        return {
          key: group.id,
          label: /* @__PURE__ */ jsx(Typography.Paragraph, { level: "small", color: "darkest", className: styles.filterOptions__groupLabel, children: group.displayName }),
          children: /* @__PURE__ */ jsx(
            Checkbox.Group,
            {
              value,
              options: options2,
              onChange: handleChange(otherOptions),
              className: styles.filterOptions__group,
              ...props
            }
          )
        };
      }),
      expandIcon: ({ isActive }) => /* @__PURE__ */ jsx(Icon, { name: isActive ? "up" : "down", sticker: "filter-options-expand-icon", size: 18 }),
      classNameWrapper: clsx(styles.filterOptions, className)
    }
  );
}
export {
  FilterOptions
};
